import { useDialogControl } from '@hooks/other/useDialogControl';
import { useGetBurnRows } from '@hooks/queries/registry/burn/useGetBurnRows';
import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid';
import { ChoiceDialog } from '../../../components/ChoiceDialog';
import { DataTable } from '../../../components/Table/DataTable';
import { Details } from '../../../components/Table/Details';
import { createColumns } from '../../../components/Table/createColumns';
import { RowNew } from '../../../components/Table/types';
import { useCreateChoices } from '../../../components/Table/useCreateChoices';
import { PageWrapper } from '../../PageWrapper';
import { RequestBurnDialog } from './RequestBurnDialog';

export const BurnsPage: React.FC = () => {
  const [selectedRow, setSelectedRow] = React.useState<RowNew | undefined>();
  const { dialogName, setDialogName, onCloseDialog } = useDialogControl();
  const onRowClick = (r: GridRowParams<RowNew>) => {
    setSelectedRow(r.row);
  };
  const { rows, isLoading } = useGetBurnRows();
  const onClose = () => {
    setSelectedRow(undefined);
  };
  const buttons = [
    {
      name: 'Request Burn',
      onClick: () => setDialogName('burn'),
    },
  ];
  const columns = createColumns();
  const actions = useCreateChoices(onClose, selectedRow);
  const pageName = (
    <Stack direction="row" sx={{ display: 'flex', flex: 1 }}>
      <Typography variant="h4" color="primary">
        Burns
      </Typography>

      {isLoading && <CircularProgress sx={{ ml: 2, mt: 0.5 }} size={20} />}
    </Stack>
  );
  return (
    <PageWrapper buttons={buttons} pageName={pageName}>
      <ChoiceDialog title="Burn details" open={!!selectedRow} onClose={onClose} actions={actions}>
        {selectedRow && <Details row={selectedRow} />}
      </ChoiceDialog>
      <RequestBurnDialog open={dialogName === 'burn'} onClose={onCloseDialog} />
      <DataTable
        rows={rows}
        rowKey={(a) => a.contractId}
        columns={columns}
        onRowClick={onRowClick}
      />
    </PageWrapper>
  );
};
